import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue'
import { createTrackEvent } from '@/composables/ai/useCareerAiTracking'

/** やめた方法。ボタンか、ダイアログの外のタップか */
type ConsentDeclineReason = 'cancel' | 'overlay'


export default /*#__PURE__*/_defineComponent({
  __name: 'CareerAiConsentDialog',
  props: {
    visible: { type: Boolean, default: false },
    dailyLimit: { default: 30 },
    submitting: { type: Boolean, default: false },
    placement: { default: 'mypage' }
  },
  emits: ["accept", "decline"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'accept'): void
  (e: 'decline', reason: ConsentDeclineReason): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { visible: boolean, dailyLimit: number, submitting: boolean, placement: string };

/**
 * AIチャット（ヤギコンシェルジュ）の利用同意ダイアログ。
 * 何ができるかを先に見せ、データの取り扱いは要点3つを常に表示、残りは「詳しく見る」で開く。
 * 表示と「詳しく見る」はここで計測する（同意・やめるの計測は呼び出し側）。
 */




// 同意前はセッションが無いので gtag だけに送る（DB ミラーは uuid と session が揃うときだけ）
const trackEvent = createTrackEvent(
  () => '',
  () => ''
)

const detailOpen = ref(false)

watch(
  () => props.visible,
  (v) => {
    if (!v) return
    detailOpen.value = false
    trackEvent('career_ai_consent_view', { placement: props.placement })
  },
  { immediate: true }
)

function toggleDetail() {
  detailOpen.value = !detailOpen.value
  if (detailOpen.value) {
    trackEvent('career_ai_consent_detail_open', {
      placement: props.placement
    })
  }
}

function decline(reason: ConsentDeclineReason) {
  emit('decline', reason)
}

return { __sfc: true,props, emit, trackEvent, detailOpen, toggleDetail, decline }
}

})